import { Link } from "react-router-dom";
import { ru } from "../../data/ru";
import { by } from "../../data/by";
import './mod.css'
import {
    COMPLEX_CREATOR_URL,
    FILTER_EDITOR_URL,
    TASK_CREATOR_URL,
    TEST_CREATOR_URL,
    TEXT_CREATOR_URL
} from "../../../config";


const Moderator = () =>{
    let language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdThree: by.RoleIdThree

	return (
        <>
		<div className="backgr">
			<div className="block1"/>
            <div className="block2"/>
		</div>
        <div className="mod_content">
            <div className="mod_block_cent1">
                <div className="mod_block_cent2">
                    <h1>{language.title}</h1>
                    <div className="mod_but">
                        <Link className="moderator-profile-button" to={TEST_CREATOR_URL}><button>{language.createTestButton}</button></Link>
                        <Link className="moderator-profile-button" to={COMPLEX_CREATOR_URL}><button>{language.createTaskButton}</button></Link>
                        <Link className="moderator-profile-button" to={TEXT_CREATOR_URL}><button>{language.createTextButton}</button></Link>
                        <Link className="moderator-profile-button" to={TASK_CREATOR_URL}><button>{language.createQuestionButton}</button></Link>
                        <Link className="moderator-profile-button" to={FILTER_EDITOR_URL}><button>{language.createFilterManagementButton}</button></Link>
                    </div>
                </div>
            </div>
        </div>
        </>

    );
}

export default Moderator;